// components/Team.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import emmanuelImg from '../images/emmanuel_458x500.webp';
import gilresImg from '../images/gilres_458x500.webp';
import mpeckImg from '../images/mpeck_458x500.webp';
import './Team.css';

const Team = () => {
  const { t } = useTranslation();

  const members = [
    {
      name: 'M. Emmanuel KAKOUANDÉ',
      role: t('fonction_ceo'),
      image: emmanuelImg,
      social: { facebook: '#', instagram: '#', linkedin: '#', tiktok: '#' }
    },
    {
      name: 'M. Gilres TOGUEM',
      role: t('fonction_secretaire_general'),
      image: gilresImg,
      social: { 
        facebook: 'https://www.facebook.com/profile.php?id=100069518353558',
        instagram: 'https://www.instagram.com/gilrestoguem',
        linkedin: 'https://www.linkedin.com/in/gilres-toguem-9a9b69238',
        tiktok: 'https://www.tiktok.com/@gilres12doc'
      }
    },
    {
      name: 'M. Étienne MPECK',
      role: t('fonction_DRH'),
      image: mpeckImg,
      social: { facebook: '#', instagram: '#', linkedin: '#', tiktok: '#' }
    }
  ];

  return (
    <section className="team-section">
      <div className="container">
        <div className="section-header text-center">
          <h2>{t('titre_Notre_equippe')}</h2>
          <h3>{t('msg1_Notre_equippe')}</h3>
          <h4 className="team-highlight">{t('msg2_Notre_equippe')}</h4>
        </div>
        <div className="team-grid">
          {members.map((member, index) => (
            <div key={index} className="team-card">
              <div className="team-image">
                <img src={member.image} alt={member.name} />
              </div>
              <div className="team-info">
                <h5>{member.name}</h5>
                <span>{member.role}</span>
                <div className="team-social">
                  <a href={member.social.facebook} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href={member.social.instagram} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href={member.social.tiktok} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-tiktok"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="team-cta">
          <p>{t('Msg_open_all_equippe')}</p>
          <a href="/apropos#allEquipe" className="btn-team-cta">
            {t('btn_decouvrir_lequippe')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Team;